module.exports = __webpack_public_path__ + "static/img/reward_icon_04.8cd5c1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/reward_icon_04.png
// module id = IDug
// module chunks = 1